var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-filter',{attrs:{"filterComponents":[
      {
        type: 'DateRangeFilter',
        name: 'whereDate',
        attributes: { dateField: 'paid_at' }
      }
    ],"autoApply":true},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table')}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('v-table',{ref:"table",attrs:{"url":"/api/v1/transaction","filter":_vm.filter,"attributes":[
      {
        attribute: 'service',
        displayedAttribute: 'translated_service',
        name: 'Zahlungsart- / Dienstleister'
      },
      {
        attribute: 'transactions',
        name: 'Käufe'
      },
      {
        attribute: 'units',
        name: 'Bezahleinheiten'
      },
      {
        attribute: 'revenue',
        name: 'Umsatz',
        type: 'CurrencyCell'
      }
    ]}},[(_vm.total)?_c('tr',{attrs:{"slot":"bottom"},slot:"bottom"},_vm._l((_vm.summaryFields),function(attribute,index){return _c('td',{key:'row-' + index},[_c('strong',[_vm._v("\n          "+_vm._s(index === 0 ? "Gesamt:" : _vm.total[attribute])+"\n        ")])])}),0):_vm._e()]),_vm._v(" "),_c('chart-card',{attrs:{"chart-data":_vm.revenueChart,"chart-options":_vm.revenueChart.options,"chart-type":"Pie","chart-height":175}},[_c('template',{slot:"header"},[_c('h5',{staticClass:"card-title"},[_vm._v("Umsätze")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("Gruppiert nach Zahlungsart- / Dienstleister")])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('div')])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }